import { PlanType } from "app/components/subscriptions/payment_info_form"
import { Currency } from "app/components/subscriptions/currency_switcher_modal"
import { PlanId } from "shared/utils/tiers"

export interface CreditsCheckoutData {
  browser_type: string
  create_stripe_customer_url: string
  currencies: Currency[]
  default_currency: string
  show_currency_switcher: boolean
  email: string
  plan: {
    product_id: string
    plan_id: PlanId
    tier: string
    currency_plans: Record<string, { monthly_plan: PlanType; yearly_plan: PlanType }>
    credits_per_month: number | null
    features: string[]
  }
  subscriptions_path: string
  setup_intent_client_secret?: string | null
  setup_intent_return_url?: string | null
  stripe_customer_preinitialized?: boolean
}

export const loadCreditsCheckout = async (planKey: string): Promise<CreditsCheckoutData> => {
  const response = await fetch(`/subscriptions/credits_modal?plan=${encodeURIComponent(planKey)}`, {
    headers: { Accept: "application/json" },
    redirect: "error",
  })
  if (!response.ok) throw new Error(`HTTP error ${response.status}`)

  return response.json()
}
